import React from "react";
import styles from "./notification-badge.module.css";
interface NotificationBadgeProps {
  count: number;
}

export default function NotificationBadge({ count }: NotificationBadgeProps) {
  return (
    <span className={styles.badge}>
      <span className={styles.dot} />
      {count}
    </span>
  );
}
